export default function () {
    const currentURL = window.location.host;
    if (currentURL.includes('localhost:3000')) {
        return 'demo'
    } else if (currentURL.includes("stresidences")) {
        return "stresidences"
    } else if (currentURL.includes("escape")) {
        return "escape2thesands"
    } else if (currentURL.includes("staging")) {
        return "staging"
    } else if (currentURL.includes("demo")) {
        return "demo"
    } else if (currentURL.includes("youarehome")) {
        return "youarehome"
    } else if (currentURL.includes("ldg")) {
        return "ldg"
    } else if (currentURL.includes("clarendon")) {
        return "clarendon"
    } else if (currentURL.includes("signet")) {
        return "signetapartments"
    } else if (currentURL.includes("charm")) {
        return "charmstay"
    } else if (currentURL.includes("cosmo")) {
        return "cosmopolitanapartments"
    } else if (currentURL.includes("citystay")) {
        return "citystayapartment"
    } else if (currentURL.includes("roomspace")) {
        return "roomspace"
    } else if (currentURL.includes("harrogate")) {
        return "harrogateapartments"
    } else if (currentURL.includes("tempstay")) {
        return "tempstay"
    } else if (currentURL.includes("kepplestone")) {
        return "kepplestonemanor"
    } else if (currentURL.includes("scandik")) {
        return "scandik"
    } else if (currentURL.includes("homa")) {
        return "homa"
    } else if (currentURL.includes("noonsg")) {
        return "noonsg"
    } else if (currentURL.includes("bnbme")) {
        return "bnbme"
    } else if (currentURL.includes("multicurrencytest2")) {
        return "multicurrencytest2"
    } else if (currentURL.includes("multicurrency")) {
        return "multicurrencytest"
    } else if (currentURL.includes("tjpad")) {
        return "tjpad"
    } else if (currentURL.includes("flyingbutler")) {
        return "flyingbutler"
    } else if (currentURL.includes("sixstays")) {
        return "sixstays"
    } else if (currentURL.includes("zomelle")) {
        return "zomelle"
    } else if (currentURL.includes("buckinghamandlloyds")) {
        return "buckinghamandlloyds"
    } else if (currentURL.includes("domusstay")) {
        return "domusstay"
    } else if (currentURL.includes("qapartments")) {
        return "qapartments"
    } else if (currentURL.includes("markeygroup")) {
        return "markeygroup"
    } else if (currentURL.includes("mabaat")) {
        return "mabaat"
    } else if (currentURL.includes("week2week")) {
        return "week2week"
    } else if (currentURL.includes("homenhancement")) {
        return "homenhancement"
    } else if (currentURL.includes("live.thecollective")) {
        return "thecollectivelive"
    } else if (currentURL.includes("collectivelive")) {
        return "thecollectivelive"
    } else if (currentURL.includes("thecollective")) {
        return "thecollective"
    } else if (currentURL.includes("citywestaparthotel")) {
        return "citywestaparthotel"
    } else if (currentURL.includes("khhomes")) {
        return "khhomes"
    } else if (currentURL.includes("basilstreetapartments")) {
        return "basilstreetapartments"
    } else if (currentURL.includes("briscoeandshaw")) {
        return "briscoeandshaw"
    } else {
        return "default"
    }
}
